import { render, staticRenderFns } from "./RatingsViewer.vue?vue&type=template&id=db790ac6&scoped=true"
import script from "./RatingsViewer.vue?vue&type=script&lang=ts"
export * from "./RatingsViewer.vue?vue&type=script&lang=ts"
import style0 from "./RatingsViewer.vue?vue&type=style&index=0&id=db790ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db790ac6",
  null
  
)

export default component.exports